<template>
  <div>
    <divisoria-descricao
      :titulo="'Endereço'"
      :descricao="'Adicione as informações sobre o endereço desta empresa'"
    />
    <b-row>
      <b-col
        cols="6"
      >
        <cep-input
          :value="endereco.cep"
          @atualizar-endereco="enderecoBuscado"
        />
      </b-col>

      <b-form-group
        label="Endereço"
        class="col-md-6"
      >
        <b-form-input
          v-model="endereco.logradouro"
        />
      </b-form-group>
    </b-row>
    <b-row>
      <b-form-group
        label="Número"
        class="col-md-2"
      >
        <b-form-input
          v-model="endereco.numero"
        />
      </b-form-group>
      <b-form-group
        label="Complemento"
        class="col-md-4"
      >
        <b-form-input
          v-model="endereco.complemento"
        />
      </b-form-group>
      <b-form-group
        label="Bairro"
        class="col-md-6"
      >
        <b-form-input
          v-model="endereco.bairro"
        />
      </b-form-group>
    </b-row>
    <b-row>
      <b-col cols="4">
        <legend class="col-form-label pt-0">
          Cidade
        </legend>
        <municipio-select
          v-model="endereco.cidade"
        />
      </b-col>
      <b-col cols="2">
        <legend class="col-form-label pt-0">
          Estado
        </legend>
        <estado-select v-model="endereco.uf" />
      </b-col>
      <b-form-group
        label="E-mail"
        class="col-md-6"
      >
        <validation-provider
          #default="{ errors }"
          name="E-mail"
          rules="email"
        >
          <b-form-input
            ref="email"
            v-model="endereco.email"
            :state="errors.length > 0 ? false:null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-row>
    <telefone-celular
      class="mb-2"
      :value="endereco.telefoneContato"
    />
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  nome: 'TabEndereco',
  components: {
    ValidationProvider,
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    TelefoneCelular: () => import('@/shared/components/telefone-celular/TelefoneCelular.vue'),
    EstadoSelect: () => import('@/shared/components/estado-select/EstadoSelect.vue'),
    MunicipioSelect: () => import('@/shared/components/municipio-select/MunicipioSelect.vue'),
    CepInput: () => import('@/@pilar/components/cep-input/CepInput.vue'),
  },
  data() {
    return {
      value: {
        telefoneContato: {
          telefoneWhatsApp: false,
          celularWhatsApp: false,
        },
      },
    }
  },
  computed: {
    endereco: {
      get() {
        return this.$store.getters['empresa/endereco']
      },
    },
  },
  methods: {
    enderecoBuscado(value) {
      this.$set(this.endereco, 'logradouro', value.logradouro)
      this.$set(this.endereco, 'bairro', value.bairro)
      this.$set(this.endereco, 'complemento', value.complemento)
      this.$set(this.endereco, 'uf', value.uf)
      this.$set(this.endereco, 'cidade', value.cidade)
      this.$set(this.endereco, 'cep', value.cep)
    },
  },
}
</script>
